import WasteRecycleCreate from '../components/views/wasteRecycle/wasteRecycleCreate.vue'
import WasteRecycle from '../components/views/wasteRecycle/wasteRecycle.vue'

const routes = [
    {
        path: 'wasteRecycle',
        component: WasteRecycle,
        name: 'wasteRecycle',
        meta: {
            description: 'List of Waste Recycle',
            title: 'Waste Recycle',
            requiresAuth: true
        }
    },
    {
        path: 'wasteRecycle/wasteRecycleCreate/:_id',
        component: WasteRecycleCreate,
        name: 'wasteRecycleCreate',
        meta: {           
            title: 'Add / Update Waste Recycle',
            requiresAuth: true
        }
    },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/wasterecycle.route.js